import getEnvironment from '../../getEnvironment';

export const getShowcaseUrl = () => {
  const { host } = window.location;
  const environment = getEnvironment(host);

  switch (environment) {
    case 'stable':
      return 'https://showcase.dev.pp.muyben.tech';
    case 'production':
      return 'https://showcase.app.productplacement.com';
    case 'local':
      return 'http://localhost:7000';
    default:
      return 'https://showcase.dev.pp.muyben.tech';
  }
};
